import type { ReactNode } from 'react';
import { Plus } from 'lucide-react';
import { AssetMarketplace } from '../../../components/marketplace';
import type { MarketplaceAsset } from '../../../types/marketplace';

export interface WorkflowPanelProps {
  assets: MarketplaceAsset[];
  /** 启用 / 禁用工作流。 */
  onToggle: (asset: MarketplaceAsset) => void;
  /** 点击编辑：页面按 id 找到工作流并打开编辑器。 */
  onEdit: (asset: MarketplaceAsset) => void;
  /** 新增工作流。 */
  onAdd: () => void;
  /** 工作流在线服务工具栏节点。 */
  toolbar: ReactNode;
}

/** 工作流维度面板：工作流橱窗（启用 / 禁用 / 新增编辑）。 */
export default function WorkflowPanel({ assets, onToggle, onEdit, onAdd, toolbar }: WorkflowPanelProps) {
  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <h3 style={{ margin: 0 }}>工作流橱窗</h3>
        <button className="primary" style={{ padding: '6px 12px', fontSize: 13 }} onClick={onAdd}>
          <Plus size={14} /> 新增工作流
        </button>
      </div>
      {toolbar}
      <AssetMarketplace
        assets={assets}
        initialType="workflow"
        hideTypeFilter
        title=""
        applyLabel="启用"
        removeLabel="禁用"
        onToggle={onToggle}
        onEdit={onEdit}
      />
    </div>
  );
}
